import { c as _c } from "react/compiler-runtime";
import { getStatusFromIssue } from "@/lib/issue/config";
import { Badge } from "../ui/badge";
export const StatusBadge = t0 => {
  const $ = _c(8);
  const {
    issue
  } = t0;
  let t1;
  if ($[0] !== issue) {
    t1 = getStatusFromIssue(issue);
    $[0] = issue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const status = t1;
  if (!status) {
    return null;
  }
  let t2;
  if ($[2] !== status.icon) {
    t2 = status.icon && <status.icon />;
    $[2] = status.icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== status.badgeVariant || $[5] !== status.label || $[6] !== t2) {
    t3 = <Badge variant={status.badgeVariant} className="gap-2">{t2}{status.label}</Badge>;
    $[4] = status.badgeVariant;
    $[5] = status.label;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};